"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/* ++++++++++ --------------- VALUE HIGHLIGHTER : DEFINITION --------------- ++++++++++ */

var _default = {
  name: 'ValueHighlighter',
  props: {
    values: {
      type: 'array',
      default: ['standard', 'highlighted', 'standard2', 'standard3', 'standard4']
    },
    valuesToHighlight: {
      type: 'array',
      default: ['highlighted']
    },
    minHeight: {
      type: 'string',
      default: '180px'
    },
    direction: {
      type: 'string',
      default: 'column',
      options: ['column', 'row']
    },
    separator: {
      type: 'string',
      default: ''
    },
    scrollable: {
      type: 'boolean',
      default: false,
      options: [true, false]
    },
    showHighlightedFirst: {
      type: 'boolean',
      default: true,
      options: [true, false]
    }
  }
};
exports.default = _default;